import {FC, useEffect, useRef, useState} from "react";
import {Container, MainContent} from "../styles";
import SidebarCardHeader from "../../SidebarCardHeader";
import {SearchInputCustom} from "../../../ui/SearchInputCustom";
import {ResultSearchContentSidebarCard} from "../../Sidebar/styles";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar/SidebarSearch";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {dataMapDirectionFilters} from "../dataMapFilters";
import {SidebarCardSearchDirectionItem} from "./SidebarCardSearchDirectionItem";
import {SidebarCardSearchEsgItem} from "./SidebarCardSearchEsgItem";

interface IProps {
  onCloseCard: () => void;
  typeRadar: ITypeRadar;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  searchDatasidebarInfo?: IDataForSearchSidebar;
}

interface IResultFindEsg {
  id: string | number;
  name: string;
  clusters: {
    id: string | number;
    name: string;
  }[];
}

export const SidebarCardSearchEsg: FC<IProps> = ({
  onCloseCard,
  typeRadar,
  openSidebarWithTab,
  searchDatasidebarInfo,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");

  const [resultSearchFind, setResultSearchFind] = useState(
    {} as IResultFindEsg[]
  );

  const [sortOption, setSortOption] = useState<string>("");
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);
  const handleSort = (option: string) => {
    console.log(option);
  };

  const handleTypeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
  };

  useEffect(() => {
    const resultsFindClusters = searchDatasidebarInfo?.clusters?.filter(
      (item) => item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    const groupedResults: IResultFindEsg[] =
      searchDatasidebarInfo?.directions?.reduce(
        (acc: IResultFindEsg[], direction) => {
          const clusters = resultsFindClusters?.filter(
            (cluster) => cluster.direction_id === direction.id
          );

          if (clusters && clusters.length > 0) {
            acc.push({
              id: direction.id,
              name: direction.name,
              clusters: clusters.map((cluster) => ({
                id: cluster.id,
                name: cluster.name,
              })),
            });
          }

          return acc;
        },
        []
      ) ?? [];

    setResultSearchFind(groupedResults);
  }, [inputSearchValue, searchDatasidebarInfo]);

  const handleSortTitle = () => {
    return `КЛАСТЕРЫ `;
  };
  return (
    <Container>
      <SidebarCardHeader
        previewTitle="Радар: «Esg»"
        title="ПОИСК ПО ПРОЕКТАМ"
        colorTitle="#53C6F5"
        onClose={onCloseCard}
        color="#858E97"
      />
      <MainContent>
        <SearchInputCustom
          searchInputRef={searchInputRef}
          inputSearchValue={inputSearchValue}
          handleTypeSearch={handleTypeSearch}
          setInputSearchValue={setInputSearchValue}
        />

        {inputSearchValue.length > 0 && (
          <div
            style={{
              color: "#fff",
              padding: "5px 0",
              zIndex: 1,
            }}
          >
            {resultSearchFind.length > 0 ? (
              <div>
                <p
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: "16px",
                    margin: "20px 0 10px",
                  }}
                >
                  Результаты:
                </p>
                {typeRadar === "esg" && (
                  <ResultSearchContentSidebarCard>
                    <div>
                      {resultSearchFind.map((item) => {
                        return (
                          <SidebarCardSearchEsgItem
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            searchDatasidebarInfo={item}
                            isShowTitleParams={isShowTitleParams}
                            typeRadar={typeRadar}
                            openSidebarWithTab={openSidebarWithTab}
                          />
                        );
                      })}
                    </div>
                  </ResultSearchContentSidebarCard>
                )}
              </div>
            ) : (
              <div
                style={{
                  padding: "5px 10px",
                  borderBottom: "1px solid rgba(255,255,255,0.1)",
                }}
              >
                Ничего не найдено
              </div>
            )}
          </div>
        )}
      </MainContent>
    </Container>
  );
};
